// extracted by mini-css-extract-plugin
module.exports = {"table":"ServicesPrices-module--table--39alj","button":"ServicesPrices-module--button--a1OYM","list":"ServicesPrices-module--list--1FTHE"};